import {
  Grid,
  Text,
  useTheme,
  usePreventWindowScroll,
} from '@simplywallst/ui-core';
import { RichTextEditor } from '@/components/RichTextEditor';
import ActionSheet, {
  Background,
  Header,
  Panel,
  Sheet,
} from '@components/ActionSheet';
import { Narrative } from '@/pages/Narrative/hooks/useNarrativeDeprecated';

type Props = {
  announcement?: Narrative['announcements'][number];
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (content: string) => void;
  ctaText?: string;
};

export const AnnouncementModal = ({
  announcement,
  isOpen,
  onClose,
  onSubmit,
  ctaText = 'Publish',
}: Props) => {
  const theme = useTheme();

  const PreventWindowScroll = () => {
    usePreventWindowScroll();
    return null;
  };

  return (
    <ActionSheet open={isOpen} onClose={onClose}>
      <Background onClick={onClose} />
      {isOpen && <PreventWindowScroll />}
      <Sheet>
        <Grid
          data-cy-id="narrative-announcement-modal"
          templateRows={`calc(40px + ${theme.safeAreaInsetTop}) auto`}
        >
          <Panel templateRows="max-content 1fr" row="2">
            <Header>
              <Text
                typography="baseStrong"
                color="white"
                data-cy-id="narrative-announcement-modal-heading"
              >
                Share Announcement
              </Text>
            </Header>
            <Grid paddingX="x3" paddingBottom="x1">
              <RichTextEditor
                defaultContent={announcement?.contentHtml}
                saveButtonText={ctaText}
                onSave={(content) => onSubmit(content.html)}
              />
            </Grid>
          </Panel>
        </Grid>
      </Sheet>
    </ActionSheet>
  );
};
